import styled from 'styled-components'
import React from 'react'
import LabelField from './LabelField'
import theme from '../utils/theme'

const Container = styled.textarea`
  border: 1px solid ${ theme.palette.grey };
  background: ${ theme.palette.light_grey };
  padding: 8px 10px;
  font-size: 12px;
  border-radius:0;
  color: ${ theme.palette.black };
  :focus {
      border: 1px solid ${ theme.palette.blue };
      background: #FFFFFF
  }
  
  :placeholder {
    color: ${ theme.palette.grey };
  }
`

const TextArea = ({ label, subLabel, direction, onValueChange, className, rows, maxlength, ...props }) => {
  return <LabelField label={ label } subLabel={ subLabel } className={ className } direction={ direction }>
    <Container rows={ rows ? rows : 10 } maxLength={ maxlength } onChange={ (ev) => {
      onValueChange && onValueChange(ev.target.value)
    } }
               { ...props }/>
  </LabelField>
}

export default TextArea
